import { Amplify } from '@aws-amplify/core';
import { copy as copy$1 } from './internal/copy.mjs';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function copy(input) {
    return copy$1(Amplify, input);
}

export { copy };
//# sourceMappingURL=copy.mjs.map
